import React from "react";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import AppointmentWithContactInfoSection from "../Section/AppointmentWithContactInfoSection";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";

export default function Appointments() {
  pageTitle("Appointments");
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/contact/HeroContacts.png"
        imgUrl="/images/appointments/banner_img.png"
        title="Don’t Delay! Book Your IVF Appointment Now"
        subTitle="Complete the form below to schedule your IVF consultation."
      />

      <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <AppointmentWithContactInfoSection />
      </Section>
    </>
  );
}
